import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = { class: "row h-100 g-0" }
const _hoisted_3 = { class: "col-12 col-md-3 col-lg-3 h-100" }
const _hoisted_4 = {
  class: "overflow-y-auto h-100 pt-4 px-3",
  style: {"height":"calc(100vh - 60px)"}
}
const _hoisted_5 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_8 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_9 = { class: "visually-hidden" }
const _hoisted_10 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "form-label" }
const _hoisted_19 = ["onUpdate:modelValue"]
const _hoisted_20 = { class: "mb-3 pb-3" }
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_23 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_24 = { class: "visually-hidden" }
const _hoisted_25 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = { value: "" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "form-label" }
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = { class: "mb-3 pb-3" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_38 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_39 = { class: "visually-hidden" }
const _hoisted_40 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "form-label" }
const _hoisted_44 = ["onUpdate:modelValue"]
const _hoisted_45 = { value: "" }
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "form-label" }
const _hoisted_49 = ["onUpdate:modelValue"]
const _hoisted_50 = { class: "col-12 col-md-9 col-lg-9 h-100 d-none d-md-block p-4" }
const _hoisted_51 = {
  class: "position-fixed h-100",
  style: {"top":"90px","left":"33%","right":"10px"}
}
const _hoisted_52 = {
  class: "h-85 bg-white shadow-sm p-4",
  style: {"border-radius":"2px"}
}
const _hoisted_53 = { class: "schematic-container position-relative h-100" }
const _hoisted_54 = { class: "component-box solar-panels" }
const _hoisted_55 = { class: "component-label" }
const _hoisted_56 = { class: "fw-bold" }
const _hoisted_57 = { class: "small text-muted" }
const _hoisted_58 = { class: "component-box inverter" }
const _hoisted_59 = { class: "component-label" }
const _hoisted_60 = { class: "fw-bold" }
const _hoisted_61 = { class: "small text-muted" }
const _hoisted_62 = { class: "component-box ev-charger" }
const _hoisted_63 = { class: "component-label" }
const _hoisted_64 = { class: "fw-bold" }
const _hoisted_65 = { class: "small text-muted" }
const _hoisted_66 = { class: "component-box grid" }
const _hoisted_67 = { class: "component-label" }
const _hoisted_68 = { class: "fw-bold" }
const _hoisted_69 = { class: "small text-muted" }
const _hoisted_70 = { class: "component-box batteries" }
const _hoisted_71 = { class: "component-label" }
const _hoisted_72 = { class: "fw-bold" }
const _hoisted_73 = { class: "small text-muted" }
const _hoisted_74 = {
  class: "col-12 d-md-none p-4",
  style: {"height":"250px"}
}
const _hoisted_75 = {
  class: "h-85 bg-white shadow-sm p-4",
  style: {"border-radius":"2px"}
}
const _hoisted_76 = { class: "schematic-container position-relative h-100" }
const _hoisted_77 = { class: "text-center text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("project.batteryAndBackup.title")), 1),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("project.batteryAndBackup.loading")), 1)
                  ])
                ]))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.error), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.batteries, (battery, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'battery-' + index,
                      class: "battery-config position-relative"
                    }, [
                      (_ctx.batteries.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removeBattery(index)),
                            class: "btn btn-close position-absolute",
                            style: {"right":"10px","top":"10px"},
                            "aria-label": "Delete battery"
                          }, null, 8, _hoisted_11))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("project.batteryAndBackup.batteryModel")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((battery.device_id) = $event),
                          class: "form-select"
                        }, [
                          _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("project.batteryAndBackup.selectModel")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.batteries, (battery) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: battery.id,
                              value: battery.id
                            }, _toDisplayString(battery.manufacturer) + " " + _toDisplayString(battery.model_number), 9, _hoisted_16))
                          }), 128))
                        ], 8, _hoisted_14), [
                          [_vModelSelect, battery.device_id]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("project.batteryAndBackup.numberOfUnits")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((battery.pcs) = $event),
                          class: "form-control",
                          min: "1"
                        }, null, 8, _hoisted_19), [
                          [_vModelText, battery.pcs]
                        ])
                      ]),
                      (index === _ctx.batteries.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addBattery && _ctx.addBattery(...args))),
                            class: "btn btn-outline-primary btn-sm"
                          }, _toDisplayString(_ctx.$t("project.batteryAndBackup.addAnotherBattery")) + " + ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ]),
          _createElementVNode("section", _hoisted_20, [
            _createElementVNode("h3", _hoisted_21, _toDisplayString(_ctx.$t("project.batteryAndBackup.evTitle")), 1),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("project.batteryAndBackup.loading")), 1)
                  ])
                ]))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.error), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.evChargers, (charger, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'charger-' + index,
                      class: "ev-charger-config position-relative"
                    }, [
                      (_ctx.evChargers.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removeCharger(index)),
                            class: "btn btn-close position-absolute",
                            style: {"right":"10px","top":"10px"},
                            "aria-label": "Delete charger"
                          }, null, 8, _hoisted_26))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("project.batteryAndBackup.evChargerModel")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((charger.device_id) = $event),
                          class: "form-select"
                        }, [
                          _createElementVNode("option", _hoisted_30, _toDisplayString(_ctx.$t("project.batteryAndBackup.selectModel")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.evChargers, (charger) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: charger.id,
                              value: charger.id
                            }, _toDisplayString(charger.manufacturer) + " " + _toDisplayString(charger.model_number), 9, _hoisted_31))
                          }), 128))
                        ], 8, _hoisted_29), [
                          [_vModelSelect, charger.device_id]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("project.batteryAndBackup.numberOfUnits")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((charger.pcs) = $event),
                          class: "form-control",
                          min: "1"
                        }, null, 8, _hoisted_34), [
                          [_vModelText, charger.pcs]
                        ])
                      ]),
                      (index === _ctx.evChargers.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addCharger && _ctx.addCharger(...args))),
                            class: "btn btn-outline-primary btn-sm"
                          }, _toDisplayString(_ctx.$t("project.batteryAndBackup.addAnotherCharger")) + " + ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ]),
          _createElementVNode("section", _hoisted_35, [
            _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.$t("project.batteryAndBackup.meterTitle")), 1),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("project.batteryAndBackup.loading")), 1)
                  ])
                ]))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.error), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.meters, (meter, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'meter-' + index,
                      class: "meter-config position-relative"
                    }, [
                      (_ctx.meters.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removeMeter(index)),
                            class: "btn btn-close position-absolute",
                            style: {"right":"10px","top":"10px"},
                            "aria-label": "Delete meter"
                          }, null, 8, _hoisted_41))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("project.batteryAndBackup.meterModel")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((meter.device_id) = $event),
                          class: "form-select"
                        }, [
                          _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.$t("project.batteryAndBackup.selectModel")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.meters, (meterModel) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: meterModel.id,
                              value: meterModel.id
                            }, _toDisplayString(meterModel.manufacturer) + " " + _toDisplayString(meterModel.model_number), 9, _hoisted_46))
                          }), 128))
                        ], 8, _hoisted_44), [
                          [_vModelSelect, meter.device_id]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("project.batteryAndBackup.numberOfUnits")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((meter.pcs) = $event),
                          class: "form-control",
                          min: "1"
                        }, null, 8, _hoisted_49), [
                          [_vModelText, meter.pcs]
                        ])
                      ]),
                      (index === _ctx.meters.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addMeter && _ctx.addMeter(...args))),
                            class: "btn btn-outline-primary btn-sm"
                          }, _toDisplayString(_ctx.$t("project.batteryAndBackup.addAnotherMeter")) + " + ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-file-plus" }, null, -1)),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.solarPanels")), 1),
                  _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.getSelectedPanelsInfo), 1)
                ])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "power-flow-arrow solar-to-inverter" }, [
                _createElementVNode("i", { class: "bi bi-arrow-down" })
              ], -1)),
              _createElementVNode("div", _hoisted_58, [
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-device-ssd" }, null, -1)),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.inverter")), 1),
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.getSelectedInvertersInfo), 1)
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "power-flow-arrow inverter-to-batteries" }, [
                _createElementVNode("i", { class: "bi bi-arrow-down-up" })
              ], -1)),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "power-flow-arrow inverter-to-ev" }, [
                _createElementVNode("i", { class: "bi bi-arrow-left" })
              ], -1)),
              _createElementVNode("div", _hoisted_62, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-ev-station" }, null, -1)),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.evCharger")), 1),
                  _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.getSelectedEVChargersInfo), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-plug" }, null, -1)),
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.grid")), 1),
                  _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.powerGrid")), 1)
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "power-flow-arrow grid-to-inverter" }, [
                _createElementVNode("i", { class: "bi bi-arrow-left-right" })
              ], -1)),
              _createElementVNode("div", _hoisted_70, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-battery-half" }, null, -1)),
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.$t("project.batteryAndBackup.components.batteries")), 1),
                  _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.getSelectedBatteriesInfo), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_74, [
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.$t("project.batteryAndBackup.mobileViewMessage")), 1)
          ])
        ])
      ])
    ])
  ]))
}